import { gql } from "@apollo/client";

export const updateExchangeRate = gql`
  mutation ExchangeRateUpdate($id: ID!, $currencyCode: String!, $exchangeRate: PositiveDecimal!) {
    exchangeUpdate(id: $id, input: { currencyCode: $currencyCode, exchangeRate: $exchangeRate }) {
      exchangeRate {
        currencyCode
        exchangeRate
        created
        updated
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const createExchangeRate = gql`
  mutation ExchangeRateCreate($currencyCode: String!, $exchangeRate: PositiveDecimal!) {
    exchangeCreate(input: { currencyCode: $currencyCode, exchangeRate: $exchangeRate }) {
      exchangeRate {
        currencyCode
        exchangeRate
        created
        updated
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const deleteExchangeRate = gql`
  mutation ExchangeRateDelete($id: ID!) {
    exchangeDelete(id: $id) {
      exchangeRate {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;
